export const SITE_URL = "https://useservd.com";
export const SHOPIFY_APP_LISTING_URL =
  "https://apps.shopify.com/meal-kit-subscriptions";
// Install buttons carry UTM tags so installs on the listing are attributed to
// the site; gatsby-browser.js adds the page path as utm_content on click.
export const SHOPIFY_APP_URL = `${SHOPIFY_APP_LISTING_URL}?utm_source=useservd.com&utm_medium=website`;
export const DEMO_STORE_URL = "https://servd-demo.myshopify.com/apps/menus";
export const SETUP_CALL_URL = "https://calendar.app.google/7M2ppx8p8WVGXjQa9";
export const CONTACT_EMAIL = "kevin@useservd.com";
